import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL_CONSTANTS } from '../../../constants/apiUrlConstants';
import { Header } from '../../Header/Header';
import { Footer } from '../../appFooter/Footer';
import { paintbrush } from '../../../constants/iconImageConstant';
import { Link } from 'react-router-dom';

interface ImageDetail {
  id: string;
  name: string;
  image: string;
  //age: string;
  age : string |null;
  drawing: string;
}

export function ArtistGallery_2022() {
  const url = API_URL_CONSTANTS.BASE_URL + API_URL_CONSTANTS.PAINTATHON_RESULT;
  const [images, setImages] = useState<ImageDetail[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedDrawing, setSelectedDrawing] = useState<ImageDetail | null>(null); 

  const fetchArtistGalleryImages = useCallback(async (year: string) => {
    try {
      const res = await axios.post(
        url,
        { params: { year } },
        { headers: { 'Content-Type': 'application/json' } }
      );

      // const groups = ['A', 'B'];
      // const combinedData = groups.flatMap(group => 
      //   (res.data?.[group] || []).filter((item: ImageDetail) => 
      //     item.age.includes(`Group ${group}`)
      //   ).slice(3) 
      // );
      const groups = ['A', 'B'];
      const combinedData: ImageDetail[] = groups.flatMap(group => {
      const groupData = res.data?.[group];

      return (Array.isArray(groupData) ? groupData : [])
        .slice(3);
    });

      setImages(combinedData);
    } catch (error) {
      console.error('Error fetching artist gallery images:', error);
    }
  }, [url]);


  const handleImageClick = (drawing: ImageDetail) => {
    setSelectedDrawing(drawing);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDrawing(null);
  };

  useEffect(() => {
    fetchArtistGalleryImages('2022');
  }, [fetchArtistGalleryImages]);


  return (
    <>
      <Header />
      <div className="container-fluid page-bgs">
        <div className="container">
          <div className="row">
            {/* Year Selection Section */}
            <div className="col-md-6">
              <div className="pain-win-yrs">
                <div className="win-list-box">
                  <div className="pain-yrs zoombt">
                    <Link to="paintathon-drawing-competition-2021">2021</Link>
                  </div>
                  <div className="pain-yrs zoombt yrs22">
                    <Link to="paintathon-drawing-competition-2022">2022</Link>
                  </div>
                  <div className="pain-yrs zoombt">
                    <Link to="paintathon-drawing-competition-2024">2024</Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Gallery Section */}
            <div className="col-md-6">
              <div className="pain-win-list-21">
                <div className="mega-win-1st list-22 wd">
                  <div className="win-tit">Artist Gallery</div>

                  <div className="col-md-6 offset-md-3 col-sm-6 offset-sm-3 mb-3 nopd">
                    <div className="row arilist">
                      {images.map((item) => (
                        <div className="col-md-4 col-sm-4 artbox" key={item.id}>
                          <div className="gropbox Artisbox" onClick={() => handleImageClick(item)}>
                            <img
                              src={`https://assets.etvbalbharat.com/${item.image}`}
                              alt={item.name}
                              width="100%"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="paintbrush-bk-main">
              <div className="paintboxmain">
                <img src={paintbrush} alt="paintbrush" loading="lazy"/>
              </div>
              <div className="bk-btn zoombt">
                <a href="/events">Back to Main Menu</a>
              </div>
            </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && selectedDrawing && (
          <div className="modal fade show"  style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" onClick={closeModal}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content paintathon-modal-bg">
                <div className="modal-header modal-he-adj">
                  <button type="button" className="close close-bg" onClick={closeModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body nopd">
                  <div className="drws">
                    <img src={`https://assets.etvbalbharat.com/${selectedDrawing.drawing}`} width="100%" alt="Drawing" loading="lazy" />
                    <div className="drw-cand-name">
                      {selectedDrawing.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}




























